import { render, staticRenderFns } from "./ConfirmAccountDialog.vue?vue&type=template&id=579ddf0a&scoped=true"
import script from "./ConfirmAccountDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmAccountDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmAccountDialog.vue?vue&type=style&index=0&id=579ddf0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579ddf0a",
  null
  
)

export default component.exports